import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { LANDINGPAGE_URL } from '../../../utils/msal-config';

const SSORedirectModal = ({ isOpen }) => {
  return (
    <Modal open={isOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 650,
          bgcolor: 'background.paper',
          border: 'none',
          outline: 'none',
          p: 4,
          borderRadius: 5,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Linked 360PAY Customer Account
        </Typography>

        <Box sx={{ marginTop: 2, marginBottom: 4 }}>
          Before you can create an ICS2 account, you'll need to sign in with our SSO provider.
          <br />
          <br />
          Click the button below to continue.
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <span></span>
          <Button href={LANDINGPAGE_URL} variant="contained">
            Sign In
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SSORedirectModal;
